import BaseRepository from "@/services/resources/repository";
import byNewsItem from "@/services/resources/mixins/query-by-news-item";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byNewsItem);
    }
}

export default Repository;
